export function textAlignValidator(textAlign) {
  return ['left', 'right', 'center'].includes(textAlign);
}
export var props = {
  modelValue: {
    default: undefined
  },
  placeholder: {
    type: String
  },
  multiple: {
    type: Boolean,
    default: false
  },
  chip: {
    type: Boolean,
    default: false
  },
  line: {
    type: Boolean,
    default: true
  },
  hint: {
    type: Boolean,
    default: true
  },
  textColor: {
    type: String
  },
  focusColor: {
    type: String
  },
  blurColor: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: false
  },
  readonly: {
    type: Boolean,
    default: false
  },
  clearable: {
    type: Boolean,
    default: false
  },
  separator: {
    type: String,
    default: ','
  },
  textAlign: {
    type: String,
    default: 'left',
    validator: textAlignValidator
  },
  validateTrigger: {
    type: Array,
    default: () => ['onChange', 'onClear', 'onClose']
  },
  rules: {
    type: Array
  },
  onFocus: {
    type: Function
  },
  onBlur: {
    type: Function
  },
  onClick: {
    type: Function
  },
  onClear: {
    type: Function
  },
  onClose: {
    type: Function
  },
  onChange: {
    type: Function
  },
  'onUpdate:modelValue': {
    type: Function
  }
};